import { EVENT_TYPES } from './event-types'

export default {
  FINANCE_AGREEMENT_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'agreement__page_viewed',
  },
  FINANCE_AGREEMENT_CONTINUE_NEXT_PAGE_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'agreement__continue_next_page_clicked',
  },
  FINANCE_AGREEMENT_LOAN_CONTRACT_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'agreement__loan_contract_clicked',
  },
  FINANCE_AGREEMENT_HOLDING_CONTRACT_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'agreement__holding_contract_clicked',
  },
  FINANCE_AGREEMENT_SALES_AGREEMENT_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'agreement__sales_agr_clicked',
  },
  FINANCE_AGREEMENT_LOAN_CONTRACT_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'agreement__loan_contract_viewed',
  },
  FINANCE_AGREEMENT_HOLDING_CERTIFICATE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'agreement__holding_certificate_viewed',
  },
  FINANCE_AGREEMENT_SALES_AGREEMENT_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'agreement__sales_agr_viewed',
  },
  FINANCE_AGREEMENT_LOAN_CONTRACT_CONTINUE_BTN_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'agreement__loan_contract_continue_btn_clicked',
  },
  FINANCE_AGREEMENT_HOLDING_CERTIFICATE_CONTINUE_BTN_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'agreement__holding_certificate_continue_btn_clicked',
  },
  FINANCE_AGREEMENT_SALES_AGREEMENT_CONTINUE_BTN_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'agreement__sales_agr_continue_btn_clicked',
  },
  FINANCE_AGREEMENT_AGREE_TO_TERMS_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'agreement__agree_to_terms_clicked',
  },
  FINANCE_AGREEMENT_LOAN_CONTRACT_ERROR_CONTRACT_NOT_SHOWN: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'agreement__loan_contract_error_contract_not_shown',
  },
  FINANCE_OPTION_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'payment__split_item_clicked',
  },
  FINANCE_CONTINUE_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'payment__continue_with_plan_clicked',
  },
  FINANCE_BACK_TO_CONFIRMATION_INSTALMENT_STEP_TRIGGERED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__back_to_confirmation_instalment_step_triggered',
  },
  FINANCE_SET_REDIRECT_FROM_3DS_TO_MERCHANT_FAILED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__set_redirect_from_3ds_to_merchant_failed',
  },
}
